import { render } from "./SearchSelect.vue?vue&type=template&id=5a285ca3"
import script from "./SearchSelect.js?vue&type=script&lang=js"
export * from "./SearchSelect.js?vue&type=script&lang=js"

import "./SearchSelect.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__